<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS SGF"
        @click.native="$router.push({ name: 'Credenciados_Finalizacoes' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
